import { Controller } from '@hotwired/stimulus';
import { useRequests } from '../mixins/requests';

export default class extends Controller {
	connect() {
		useRequests(this);
	}

	async submit(evt) {
		evt.preventDefault();
		evt.stopPropagation();

		const form = evt.target;
		const errorMessage = form.querySelector('[data-assignment-error]');
		errorMessage.hidden = true;
		errorMessage.textContent = '';

		const options = {
			method: 'POST',
			body: new FormData(form),
		};

		const data = await this.fetch(form.action, options);

		if (data.error) {
			errorMessage.textContent = typeof data.error === 'string' ? data.error : 'Une erreur est survenue. Veuillez réessayer.';
			errorMessage.hidden = false;
			errorMessage.focus();
			return;
		}

		data.forEach((item) => {
			this.element.querySelector(item.target).outerHTML = item.html;
		});
	}
}
